
export function userLogout() {

  return { type: 'USER_LOGOUT' }
}


// WEBPACK FOOTER //
// ./src/actions/global.js